export const INVOICE_START_TYPE = {
  GENERATE_INVOICE: 'generateInvoice',
  CREATE_INVOICE: 'createInvoice'
};
export const INVOICE_STATUS = {
  DRAFT: 'draft',
  OPEN: 'open',
  PAID: 'paid',
  VOIDED: 'voided'
};
export const INVOICE_PAYMENT_METHOD = {
  MANUAL: 'manual'
};
export const ANCHOR_TAG_LINK = {
  PAYMENTS_GET_SETUP: 'paymentsGetSetUp'
};
export const OPEN_USE_CASE_MODAL_QUERY_PARAM = 'modal=useCases';
export const INVOICE_ONBOARDING_STEP = {
  START: 'start',
  REVIEW: 'review',
  COLLECT: 'collect',
  PAID: 'paid'
};
export const INVOICE_ONBOARDING_STEP_KEYS = [INVOICE_ONBOARDING_STEP.START, INVOICE_ONBOARDING_STEP.REVIEW, INVOICE_ONBOARDING_STEP.COLLECT, INVOICE_ONBOARDING_STEP.PAID];
export const PORTAL_ID_REGEX = new RegExp(/\/[0-9]+/, 'g');